// extracted by mini-css-extract-plugin
module.exports = {"root":"MiniCard_root__3h-bx","title":"MiniCard_title__18Dqb","main":"MiniCard_main__sviEE","cardBg":"MiniCard_cardBg__15VIJ"};